import Vue from 'vue';
import App from './App.vue';
import store from './store';
import '@mdi/font/scss/materialdesignicons.scss';

// const debug = process.env.NODE_ENV !== 'production';

var pluginInstallHandler = null;

try {
	pluginInstallHandler = require('./pluginInstallHandler.js');
} catch (err) {
	pluginInstallHandler = require('./defaultPluginInstallHandler.js');
}

Vue.config.productionTip = false;

const promiseClass = function(pluginName) {
	let obj = {
		pluginName,
		events: [
			'getDepCode',
			'ready',
			'declareFunctionalities',
			'install',
			'renderMsgBody',
			'resourceExts',
			'inputExts',
			'newMsg',
			'displayNotification'
		],
		on: {},
		once: {},
		onId: {},
		onceId: {},

		init(worker) {
			return new Promise((resolve, reject) => {
				worker.onmessage = e => {
					let data = e.data;
					console.log('main received from', this.pluginName, data);
					if (typeof data === 'object') {
						if (data.hasOwnProperty('resolveId')) {
							if (this.onceId.hasOwnProperty(data.resolveId)) {
								for (
									let funcI = 0;
									funcI < this.onceId[data.resolveId].length;
									funcI++
								) {
									this.onceId[data.resolveId][funcI](data);
								}
								for (
									let funcI = 0;
									funcI < this.onceId[data.resolveId].length;
									funcI++
								) {
									this.removeOnceId(
										data.resolveId,
										this.onceId[data.resolveId][funcI]
									);
								}
							}
							if (this.onId.hasOwnProperty(data.resolveId)) {
								for (
									let funcI = 0;
									funcI < this.onId[data.resolveId].length;
									funcI++
								) {
									this.onId[data.resolveId][funcI](data);
								}
							}
						}

						for (
							let eventI = 0;
							eventI < this.events.length;
							eventI++
						) {
							let event = this.events[eventI];

							if (data.hasOwnProperty(event)) {
								for (
									let funcI = 0;
									funcI < this.once[event].length;
									funcI++
								) {
									this.once[event][funcI](data[event]);
								}
								for (
									let funcI = 0;
									funcI < this.once[event].length;
									funcI++
								) {
									this.removeOnce(
										event,
										this.once[event][funcI]
									);
								}
								for (
									let funcI = 0;
									funcI < this.on[event].length;
									funcI++
								) {
									this.on[event][funcI](data[event]);
								}
							}
						}
					}
				};

				console.log(
					'initialized promiseClass',
					this.pluginName,
					worker,
					this
				);

				resolve();
			});
		},

		addOn(event, func) {
			store.commit('pluginPromise_addOn', [this.pluginName, event, func]);
		},
		removeOn(event, func) {
			store.commit('pluginPromise_removeOn', [
				this.pluginName,
				event,
				func
			]);
		},

		addOnce(event, func) {
			store.commit('pluginPromise_addOnce', [
				this.pluginName,
				event,
				func
			]);
		},
		removeOnce(event, func) {
			store.commit('pluginPromise_removeOnce', [
				this.pluginName,
				event,
				func
			]);
		},

		addOnId(id, func) {
			store.commit('pluginPromise_addOnId', [this.pluginName, id, func]);
		},
		removeOnId(id, func) {
			store.commit('pluginPromise_removeOnId', [
				this.pluginName,
				id,
				func
			]);
		},

		addOnceId(id, func) {
			store.commit('pluginPromise_addOnceId', [
				this.pluginName,
				id,
				func
			]);
		},
		removeOnceId(id, func) {
			store.commit('pluginPromise_removeOnceId', [
				this.pluginName,
				id,
				func
			]);
		}
	};

	for (let eventI = 0; eventI < obj.events.length; eventI++) {
		let event = obj.events[eventI];
		obj.on[event] = [];
		obj.once[event] = [];
	}

	return obj;
};

const initWorkerPromise = function(pluginName, worker) {
	return new Promise(resolve => {
		const promise = promiseClass(pluginName);

		store.commit('registerPlugin', [pluginName, worker, promise]);

		promise.init(worker).then(() => {
			console.log('initted promise worker', pluginName);

			promise.addOn('getDepCode', ({ depPath, depType }) => {
				pluginInstallHandler.getDepCode(
					pluginName,
					promise,
					worker,
					depPath,
					depType,
					store
				);
			});
			promise.addOnce('ready', pluginReady => {
				store.commit('pluginReady', pluginName);
			});
			promise.addOn('declareFunctionalities', declareFunctionalities => {
				store.commit('pluginSetDeclaredFunctionalities', [
					pluginName,
					declareFunctionalities
				]);
			});
			promise.addOn('install', iPluginName => {
				VueApp.installPlugin(iPluginName);
			});
			promise.addOn('resourceExts', resourceExts => {
				store.commit('pluginSetResourceExts', [
					pluginName,
					resourceExts
				]);
			});
			promise.addOn('inputExts', inputExts => {
				store.commit('pluginSetInputExts', [pluginName, inputExts]);
			});
			promise.addOn('displayNotification', notification => {
				store.dispatch('displayNotification', [
					pluginName,
					notification
				]);
			});

			resolve(promise);

			worker.postMessage('registered');
		});
	});
};

Vue.prototype.installPlugin = function(pluginName) {
	pluginInstallHandler.installPlugin(pluginName, initWorkerPromise, store);
};

let VueApp = new Vue({
	store,
	render: h => h(App),
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				window.requestAnimationFrame(() => {
					document
						.getElementById('app-loader')
						.setAttribute('loaded', true);
				});
			}, 200);
		});
	}
}).$mount('#app');

window.VueApp = VueApp;
